import { IUserTimeOffs } from '@tsin-core/states/staff/staff';
import { UserRoleEnum } from '@tsin-shared/utils/options';

export interface AuthRequestModel {
    userId: string;
    authId: string;
}

export interface AuthStateModel {
    auth: AuthModel;
    loading: boolean;
    error: any | null;
    referralJobSlug?: string | null;
    isOtpValidated?: boolean;
    secret?: string | null;
    qrText?: string | null;
}

export enum OTP_MEANS {
    APP = 'App',
    EMAIL = 'Email',
    NONE = 'None',
    PASSKEY = 'Passkey'
}

export interface AuthModel {
    authToken: string | null;
    token: string | null;
    refreshToken: string | null;
    id: string | null;
    email: string | null;
    isOtpEnabled: boolean;
    otpMeans: OTP_MEANS.APP | OTP_MEANS.EMAIL | OTP_MEANS.NONE | OTP_MEANS.PASSKEY;
    isStaff: boolean;
    user: UserModel | null;
    isGeneratedPassword?: boolean;
    skipValidation?: boolean;

    profiles?: ProfileModel[];

    loading?: boolean;
}

export interface ProfileModel {
    id: string;
    role: UserRoleEnum;
    project: string;
}

export interface UserModel {
    office: string;
    _id: string;
    staffType: string;
    email: string;
    phone: string;
    avatar: string;
    firstName: string;
    managerId: string;
    lastName: string;
    gender: string;
    dateOfBirth: Date;
    legalStatus: string;
    countryOfBirth: string;
    motherTongue: string;
    streetAdress: string;
    unitNumber: number;
    country: string;
    state: string;
    city: string;
    zipCode: string;
    emergencyName: string;
    emergencyRelationship: string;
    emergencyPhone: string;
    emergencyEmail: string;
    univer: string;
    department: string;
    degreeProgrammArea: string;
    degreeAchived: string;
    educationCountry: string;
    practiceLang: string;
    yearsOfPractice: string;
    educationLang: string;
    role: string;
    status: string;
    learnerNumber: string;
    learnerType: string;
    uploadDate: Date;
    isCanContact: boolean;
    accountStatus: string;
    accountType: string;
    authId: string;
    isStaff: boolean;
    updatedAt: Date;
    examType: string;
    id: string;
    learningId: string;
    learningProgramId: string;
    sponsored: string;
    createdAt: Date;
    userTimeOff: IUserTimeOffs;
}

export interface LearnerUserModel {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    avatar: string;
    applicationNo: string;
    programNo: string;
    examType: string;
    status: string;
    familyMedicine: boolean;
    associatedMedicalSchool: string;
    postgraduateTrainingProgram: string;
    PGYLevel: string;
    PEAPStartDate: Date;
    PEAPEndDate: Date;
    imgBursaryAcknowledgement: boolean;
    imgBursaryVoidCheque?: string;
    imgBursarySocialInsuranceNumber: string;
    adminAssigned?: string;
}
